package com.essntl.features.country.data.supabase

import com.essntl.core.supabase.SupabaseDataSource
import io.github.jan.supabase.SupabaseClient
import org.koin.core.annotation.Single

@Single(binds = [CountrySupabaseDataSource::class])
internal class CountrySupabaseDataSource(
    override val supabaseClient: SupabaseClient,
) : SupabaseDataSource<CountryDto> {
    override val tableName: String = "country"
}
